const moneyFormat = document.currentScript.getAttribute('money-format') || "${{amount}}";
const cartCurrencyIsoCode = document.currentScript.getAttribute('cart-currency-iso-code') || "";
//const baseAppProxy = '/apps/shopqse-3d-ring-creator';
const baseAppProxy = 'https://phpstack-1090158-4665907.cloudwaysapps.com';

$(document).ready(function () {
    $('.custom-filter--shapes-slider').slick({
        dots: false,
        speed: 300,
        infinite: false,
        slidesToShow: 11,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev"><svg class="icon-left-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16016 14.3198C11.1082 14.3198 14.3203 11.1077 14.3203 7.15967C14.3203 3.21162 11.1082 -0.000489516 7.16016 -0.000489861C3.21211 -0.000490206 1.74354e-08 3.21162 -3.27714e-07 7.15967C-6.72862e-07 11.1077 3.21211 14.3198 7.16016 14.3198ZM7.16016 0.89453C10.6148 0.89453 13.4253 3.705 13.4253 7.15967C13.4253 10.6143 10.6148 13.4248 7.16016 13.4248C3.70549 13.4248 0.895019 10.6143 0.895019 7.15967C0.89502 3.705 3.70549 0.894529 7.16016 0.89453ZM4.15871 7.47606C3.98384 7.30119 3.98384 7.01803 4.15871 6.84328L6.39626 4.60573C6.48363 4.51835 6.5982 4.47461 6.71265 4.47461C6.8271 4.47461 6.94166 4.51835 7.02904 4.60573C7.2039 4.78059 7.2039 5.06376 7.02904 5.23851L5.55539 6.71216L9.84522 6.71216C10.0924 6.71216 10.2927 6.91231 10.2927 7.15967C10.2927 7.40703 10.0924 7.60718 9.84521 7.60718L5.55539 7.60718L7.02904 9.08083C7.2039 9.25569 7.2039 9.53885 7.02904 9.71361C6.85417 9.88836 6.57101 9.88847 6.39626 9.71361L4.15871 7.47606Z" fill="#183E40"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="icon-right-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16 0C3.21204 0 0 3.21204 0 7.16C0 11.108 3.21204 14.32 7.16 14.32C11.108 14.32 14.32 11.108 14.32 7.16C14.32 3.21204 11.108 0 7.16 0ZM7.16 13.425C3.70541 13.425 0.895 10.6146 0.895 7.16C0.895 3.70541 3.70541 0.895 7.16 0.895C10.6146 0.895 13.425 3.70541 13.425 7.16C13.425 10.6146 10.6146 13.425 7.16 13.425ZM10.1614 6.84362C10.3362 7.01848 10.3362 7.30163 10.1614 7.47638L7.92388 9.71388C7.83651 9.80126 7.72195 9.845 7.6075 9.845C7.49305 9.845 7.37849 9.80126 7.29112 9.71388C7.11626 9.53902 7.11626 9.25587 7.29112 9.08112L8.76474 7.6075H4.475C4.22787 7.6075 4.0275 7.40736 4.0275 7.16C4.0275 6.91264 4.22787 6.7125 4.475 6.7125H8.76474L7.29112 5.23888C7.11626 5.06402 7.11626 4.78087 7.29112 4.60612C7.46598 4.43137 7.74913 4.43126 7.92388 4.60612L10.1614 6.84362Z" fill="#183E40"/></svg></button>',
        responsive: [
            {
                breakpoint: 1101,
                settings: {
                    slidesToShow: 9
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 8
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 7
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 601,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 575,
                settings: "unslick"
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
});

const $slider_carat = document.getElementById('custom-filter--slider-carat');
const $slider_price = document.getElementById('custom-filter--slider-price');
const $slider_clarity = document.getElementById('custom-filter--slider-clarity');
const $slider_cut = document.getElementById('custom-filter--slider-cut');
const $slider_table = document.getElementById('custom-filter--slider-table');
const $slider_depth = document.getElementById('custom-filter--slider-depth');
const $slider_color = document.getElementById('custom-filter--slider-color');
const $slider_polish = document.getElementById('custom-filter--slider-polish');
const $slider_symmetry = document.getElementById('custom-filter--slider-symmetry');
const $slider_fluorescence = document.getElementById('custom-filter--slider-fluorescence');

let ajaxCallDiamondListRunning = 'No', myCustomController = null, isQueryParams = 'No', totalResultIndex = 0, totalCount = 0;
window.LB_GROWN_DIAMOND = function() {
    return {
        config: {},
        callBeforeLGDiamond: async function () {
            if (myCustomController !== null) {
                myCustomController.abort();
            }
            totalResultIndex = 0;
            window.LB_GROWN_DIAMOND.config.page_number = 1;
            ajaxCallDiamondListRunning = 'No';
            document.getElementById('search_diamond_count').innerHTML = `0 RESULTS`;
            document.querySelector("#collection-grid-html") && (document.querySelector("#collection-grid-html").innerHTML = "");
            document.querySelector("#collection-list-html") && (document.querySelector("#collection-list-html").innerHTML = "");
            // document.getElementById('diamond-overview-details') && (document.getElementById('diamond-overview-details').innerHTML = '');
            window.LB_GROWN_DIAMOND.hideElements('.collection__results-pagination');
            await window.LB_GROWN_DIAMOND?.callDiamondList();
        },
        callDiamondList: async function () {
            if (ajaxCallDiamondListRunning == 'No') {
                ajaxCallDiamondListRunning = 'Yes';
               
                sliderCaratValue1 = '';
                sliderCaratValue2 = '';
                if (defaultCaratMin?.length > 0 && defaultCaratMax?.length > 0) {
                    sliderCaratValue1 = $slider_carat?.value1;
                    sliderCaratValue2 = $slider_carat?.value2;
                }
                const page_number = window.LB_GROWN_DIAMOND?.config.page_number;

                myCustomController = new AbortController();
                const myCustomSignal = myCustomController.signal;

                var formData = new FormData();
                formData.append("action", "getAllFilterProducts");
                formData.append("shop", Shopify.shop);
                formData.append("page_number", page_number);
                formData.append("page_size", Number(document.getElementById('products-count-select').value));
                formData.append("shape", window.LB_GROWN_DIAMOND.config.shapeValue);
                formData.append("shape_data", shapeData);

                formData.append("color", $slider_color ? `${$slider_color.value1},${$slider_color.value2}` : '');
                formData.append("clarity", $slider_clarity ? `${$slider_clarity.value1},${$slider_clarity.value2}` : '');
                formData.append("cut", $slider_cut ? `${$slider_cut.value1},${$slider_cut.value2}` : '');
                formData.append("polish", $slider_polish ? `${$slider_polish.value1},${$slider_polish.value2}` : '');
                formData.append("symmetry", $slider_symmetry ? `${$slider_symmetry.value1},${$slider_symmetry.value2}` : '');
                formData.append("fluor", $slider_fluorescence ? `${$slider_fluorescence.value1},${$slider_fluorescence.value2}` : '');

                formData.append("lab", window.LB_GROWN_DIAMOND.config.certifiedByValue);
                formData.append("lab_data", certifiedByData);

                formData.append("price_min", $slider_price ? $slider_price?.value1 : '');
                formData.append("price_max", $slider_price ? $slider_price?.value2 : '');

                formData.append("carat_min", $slider_carat ? $slider_carat?.value1 : '');
                formData.append("carat_max", $slider_carat ? $slider_carat?.value2 : '');

                formData.append("table_min", $slider_table ? $slider_table?.value1 : '');
                formData.append("table_max", $slider_table ? $slider_table?.value2 : '');

                formData.append("depth_min", $slider_depth ? $slider_depth?.value1 : '');
                formData.append("depth_max", $slider_depth ? $slider_depth?.value2 : '');

                formData.append("sorting_field", window.LB_GROWN_DIAMOND.config.sortingField);
                formData.append("sorting_seq", window.LB_GROWN_DIAMOND.config.sortingSeq);
                formData.append("total_count", totalCount);

                const jsonData = window.LB_GROWN_DIAMOND.formDataToJson(formData, ['action', 'shop', 'sorting_field', 'sorting_seq', 'clarity_data', 'cut_data', 'polish_data', 'symmetry_data', 'fluor_data', 'lab_data', 'shape_data', 'color_data', 'page_size', 'total_count']); // , 'page_number'
                if (Object.keys(jsonData)?.length > 0) {
                    const url = new URL(window.location);
                    Object.keys(jsonData).forEach(key => jsonData[key]?.length > 0 && url.searchParams.set(key, jsonData[key]));
                    history.replaceState(null, '', url);
                }

                var requestOptions = { signal: myCustomSignal, method: 'POST', body: formData };
                window.LB_GROWN_DIAMOND.showElements('.load-more-div');
                window.LB_GROWN_DIAMOND.hideElements('#diamond-overview-details');
                fetch(`${baseAppProxy}/frontend.php`, requestOptions)
                    .then(response => response.text())
                    .then(result => {
                        isQueryParams = 'No';
                        if (window.LB_GROWN_DIAMOND.isJsonOrString(result) == true) {
                            let resultArray = JSON.parse(result), diamondsArray = [];
                            if (resultArray?.main_data?.response?.body?.diamonds != undefined) {
                                diamondsArray = resultArray?.main_data?.response?.body?.diamonds;
                            }

                            if (diamondsArray.length > 0) {
                                ajaxCallDiamondListRunning = 'No';
                                totalCount = resultArray?.total_count;
                                document.getElementById('search_diamond_count').innerHTML = `${resultArray?.total_count} RESULTS`;
                                let errorSrc = `this.src='${baseAppProxy}/images/no-image.png'`;
                                for (x = 0; x < (diamondsArray?.length); x++) {
                                    const diamondsObject = diamondsArray[x];
                                    const dynamic_id = `pro-data-${diamondsObject.id}`;

                                    let staticHandle = window.LB_GROWN_DIAMOND.getUrlParameter('ring-handle') !== undefined ? window.LB_GROWN_DIAMOND.getUrlParameter('ring-handle') : '';
                                    let ringProductURL = `/collections/engagement-ring-settings-collections?stone-stock=${diamondsObject?.stock_num}&filter.p.m.custom.shape=${diamondsObject?.shape}&steps=settings`;
                                    if (window.LB_GROWN_DIAMOND.getUrlParameter('ring-handle') !== undefined) {
                                        ringProductURL = `/products/${staticHandle}?stone-stock=${diamondsObject?.stock_num}`;
                                        if (window.LB_GROWN_DIAMOND.getUrlParameter('review') !== undefined) {
                                            ringProductURL += `&review=true`;
                                        }
                                    }

                                    var htmlGrid;
                                    if (x == 3) {
                                        htmlGrid = `<li class="collection__results-grid--item grid__item">
                                            <div class="collection__results-grid--offer-image">
                                                <a href="#">
                                                    <img src="https://cdn.shopify.com/s/files/1/0630/0300/1005/files/offer-image.png?v=1719476944"
                                                        alt="Product Image" width="100%" height="100%" loading="eager">
                                                </a>
                                            </div>
                                        </li>`;
                                    } else {
                                        htmlGrid = `<li class="collection__results-grid--item grid__item">
                                            <a href="${ringProductURL}">
                                                <div class="collection__results-grid--product-image">
                                                    <img src="${diamondsObject?.image_url}" onerror="${errorSrc}" alt="${diamondsObject?.short_title}" width="100%" height="100%" loading="eager">
                                                </div>
                                                <div class="collection__results-grid--product-info">
                                                    <div class="collection__results-grid--product-content">
                                                        <h3 class="collection__results-grid--product-title">${diamondsObject?.long_title}</h3>
                                                        <div class="price price--sale">
                                                            ${/* <span class="price-regular">$1,410</span> */''}
                                                            <span class="price-sale">${diamondsArray[x]?.total_sales_price?.length > 0 ? window.LB_GROWN_DIAMOND.formatMoney(Number(window.LB_GROWN_DIAMOND.priceInShopCurrency(diamondsObject?.total_sales_price)) * 100) : "-"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>`;
                                    }

                                    // collection__results-list-item--active
                                    let svgURL = diamondsObject?.shape?.length > 0 ? `${baseAppProxy}/public/icons/icon-shape-${window.LB_GROWN_DIAMOND.handleize(diamondsObject?.shape)}.svg` : `${baseAppProxy}/images/no-image.png`;
                                    var htmlList = `<div class="collection__results-list-item" id="list-view-product-${diamondsObject?.id}">
                                        <textarea id="${dynamic_id}-textarea" style="display:none;">${JSON.stringify(diamondsObject)}</textarea>
                                        <div class="collection__results-list-item-values list-item-hover collection__results-list-action" data-list-id="list-view-product-${diamondsObject?.id}" data-id="${dynamic_id}" data-image="${diamondsObject?.image_url}" data-onerror="${errorSrc}" data-video="${diamondsObject?.video_url?.length > 0?diamondsObject?.video_url:''}" data-display="true">
                                            <div class="collection__results-list-item-value collection__results-list-shape">
                                                <img src="${svgURL}" width="31" height="31" loading="eager">
                                                <span>${diamondsObject?.shape?.length > 0 ? diamondsObject?.shape : '-'}</span>
                                            </div>
                                            <div class="collection__results-list-item-value collection__results-list-cut">${diamondsObject?.cut?.length > 0 ? diamondsObject?.cut : '-'}</div>
                                            <div class="collection__results-list-item-value collection__results-list-color">${diamondsObject?.color?.length > 0 ? diamondsObject?.color : '-'}</div>
                                            <div class="collection__results-list-item-value collection__results-list-carat">${diamondsObject?.size?.length > 0 ? diamondsObject?.size : '-'}</div>
                                            <div class="collection__results-list-item-value collection__results-list-clarity">${diamondsObject?.clarity?.length > 0 ? diamondsObject?.clarity : '-'}</div>
                                            <div class="collection__results-list-item-value collection__results-list-certificate">${diamondsObject?.lab?.length > 0 ? diamondsObject?.lab : '-'}</div>
                                            <div class="collection__results-list-item-value collection__results-list-price">${window.LB_GROWN_DIAMOND.formatMoney(parseFloat(window.LB_GROWN_DIAMOND.priceInShopCurrency(diamondsObject?.total_sales_price)) * 100)}</div>
                                            <div class="collection__results-list-item-value">
                                                <span>Details</span>
                                                <span>
                                                    <svg class="icon-down-arrow" width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M20.4463 5.74401C20.3706 5.66874 20.2682 5.62649 20.1614 5.62649C20.0546 5.62649 19.9522 5.66874 19.8765 5.74401L17.9247 7.72616C17.8655 7.74527 17.8116 7.77777 17.7671 7.82112L11.071 14.5212L4.37492 7.8191C4.33039 7.77575 4.27646 7.74325 4.21732 7.72413L2.26548 5.74805C2.22893 5.7073 2.18449 5.67441 2.13485 5.65136C2.0852 5.6283 2.0314 5.61558 1.97669 5.61395C1.92198 5.61232 1.86751 5.62182 1.81658 5.64187C1.76566 5.66193 1.71934 5.69212 1.68043 5.73062C1.64152 5.76911 1.61084 5.81511 1.59025 5.86582C1.56965 5.91653 1.55957 5.9709 1.56062 6.02562C1.56167 6.08034 1.57382 6.13428 1.59635 6.18417C1.61887 6.23405 1.65129 6.27884 1.69164 6.31582L10.7841 15.5477C10.8216 15.5855 10.8663 15.6156 10.9156 15.6361C10.9648 15.6566 11.0176 15.6672 11.071 15.6672C11.1243 15.6672 11.1772 15.6566 11.2264 15.6361C11.2756 15.6156 11.3203 15.5855 11.3579 15.5477L20.4503 6.31582C20.4876 6.27802 20.5171 6.23324 20.5371 6.18404C20.5571 6.13484 20.5672 6.08218 20.5668 6.02907C20.5665 5.97597 20.5556 5.92346 20.5349 5.87454C20.5143 5.82563 20.4841 5.78127 20.4463 5.74401Z" fill="#3C3737"/>
                                                    </svg>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="collection__results-list-item-card">
                                            <div class="collection__results-card-details">
                                                <span class="icon-close-wrapper" data-list-id="list-view-product-${diamondsObject?.id}" data-id="${dynamic_id}">
                                                    <svg class="icon-close" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_556_1789)"><path d="M7.691 6.51071L12.7529 1.44861C13.0824 1.11934 13.0824 0.586962 12.7529 0.257693C12.4237 -0.0715749 11.8913 -0.0715749 11.562 0.257693L6.49993 5.31979L1.43799 0.257693C1.10856 -0.0715749 0.576335 -0.0715749 0.247067 0.257693C-0.0823556 0.586962 -0.0823556 1.11934 0.247067 1.44861L5.30901 6.51071L0.247067 11.5728C-0.0823556 11.9021 -0.0823556 12.4345 0.247067 12.7637C0.411161 12.928 0.626921 13.0105 0.842526 13.0105C1.05813 13.0105 1.27374 12.928 1.43799 12.7637L6.49993 7.70163L11.562 12.7637C11.7263 12.928 11.9419 13.0105 12.1575 13.0105C12.3731 13.0105 12.5887 12.928 12.7529 12.7637C13.0824 12.4345 13.0824 11.9021 12.7529 11.5728L7.691 6.51071Z" fill="black" /></g>
                                                        <defs><clipPath id="clip0_556_1789"><rect width="13" height="13" fill="white" /></clipPath></defs>
                                                    </svg>
                                                </span>
                                                <div class="collection__results-card-image product-image-frame">
                                                    <img class="${dynamic_id}-image-desk" alt="${diamondsObject?.short_title}" width="100%" height="100%" loading="lazy"> 
                                                    ${diamondsObject?.video_url ? '<iframe width="100%" class="'+dynamic_id+'-video-desk" src="" style="opacity:0;" frameborder="0" allow="autoplay"></iframe>' : ""}
                                                    ${diamondsObject?.video_url ? (`<span class="icon-wrapper play-button">
                                                        <svg class="icon-circle-play" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11 0C4.92491 0 0 4.92491 0 11C0 17.0751 4.92491 22 11 22C17.0755 22 22 17.0751 22 11C22 4.92491 17.0755 0 11 0ZM11 19.8C6.14767 19.8 2.2 15.8523 2.2 11C2.2 6.14767 6.14767 2.2 11 2.2C15.8523 2.2 19.8 6.14767 19.8 11C19.8 15.8523 15.8523 19.8 11 19.8Z" fill="black"/>
                                                            <path d="M15.0012 10.2299L9.66663 7.14989C8.93315 6.72661 8.33301 7.07289 8.33301 7.91989V14.0799C8.33301 14.9269 8.93315 15.2736 9.66663 14.8499L15.0012 11.7699C15.7347 11.3466 15.7347 10.6532 15.0012 10.2299Z" fill="black"/>
                                                        </svg>
                                                    </span>`):''}
                                                </div>
                                                <div class="collection__results-card-info">
                                                    <h2 class="collection__results-card-title">${diamondsObject?.size} Carat ${diamondsObject?.shape} Cut Lab-Created Diamond</h2>
                                                    <a href="javascript:;" class="need-help-talk-to-an-expert"><p class="help-text">Need Help? Talk to an expert.</p></a>
                                                    <div class="collection__results-info-wrapper">
                                                        <div class="collection__results-info-list">
                                                            <div class="collection__results-info-list-left">
                                                                <div class="collection__results-info-item">
                                                                    <div class="collection__results-list-label">Price:</div>
                                                                    <div class="collection__results-list-value">${window.LB_GROWN_DIAMOND.formatMoney(parseFloat(window.LB_GROWN_DIAMOND.priceInShopCurrency(diamondsObject?.total_sales_price)) * 100)}</div>
                                                                </div>
                                                                <div class="collection__results-info-item">
                                                                    <div class="collection__results-list-label">SKU:</div>
                                                                    <div class="collection__results-list-value">${diamondsObject?.stock_num?.length > 0 ? diamondsObject?.stock_num : '-'}</div>
                                                                </div>
                                                                <div class="collection__results-info-item">
                                                                    <div class="collection__results-list-label">Carat:</div>
                                                                    <div class="collection__results-list-value">${diamondsObject?.size?.length > 0 ? diamondsObject?.size : '-'}</div>
                                                                </div>
                                                                <div class="collection__results-info-item">
                                                                    <div class="collection__results-list-label">Cut:</div>
                                                                    <div class="collection__results-list-value">${diamondsObject?.cut?.length > 0 ? diamondsObject?.cut : '-'}</div>
                                                                </div>
                                                            </div>
                                                            <div class="collection__results-info-list-right">
                                                                <div class="collection__results-info-item-top">
                                                                    <div class="collection__results-info-item">
                                                                        <div class="collection__results-list-label">Color:</div>
                                                                        <div class="collection__results-list-value">${diamondsObject?.color?.length > 0 ? diamondsObject?.color : '-'}</div>
                                                                    </div>
                                                                    <div class="collection__results-info-item">
                                                                        <div class="collection__results-list-label">Clarity:</div>
                                                                        <div class="collection__results-list-value">${diamondsObject?.clarity?.length > 0 ? diamondsObject?.clarity : '-'}</div>
                                                                    </div>
                                                                    <div class="collection__results-info-item">
                                                                        <div class="collection__results-list-label">Certificate:</div>
                                                                        <div class="collection__results-list-value" style="white-space: normal;">${diamondsObject?.lab?.length > 0 ? diamondsObject?.lab : '-'}</div>
                                                                    </div>
                                                                </div>
                                                                ${/*<div class="collection__results-info-item-bottom">
                                                                    <div class="collection__results-info-item">
                                                                        <a href="javascript:;" class="collection__results-list-value more-details" style="width: 100%;text-align: left;text-decoration: underline;">View More Details</a>
                                                                    </div>
                                                                </div>*/''}
                                                            </div>
                                                        </div>
                                                        <div class="collection__results-card-actions">
                                                            <div class="buttons-wrapper">
                                                                <a class="button custom-button custom-button--primary" href="${ringProductURL}">${window.LB_GROWN_DIAMOND.getUrlParameter('ring-handle') !== undefined ? 'select': 'Add to ring'}</a>
                                                                ${window.LB_GROWN_DIAMOND.getUrlParameter('ring-handle') === undefined ? `<a class="button custom-button custom-button--secondary add-to-cart" data-select-item="${dynamic_id}" href="javascript:;">Add to cart</a>`:""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>`;
                                    document.querySelector("#collection-grid-html") && (document.querySelector("#collection-grid-html").innerHTML += htmlGrid);
                                    document.querySelector("#collection-list-html") && (document.querySelector("#collection-list-html").innerHTML += htmlList);
                                    totalResultIndex++;
                                }

                                if (resultArray?.page_count > 1 && window.LB_GROWN_DIAMOND.conObjToArrElements('.collection__results-pagination')?.length > 0) {
                                    let paginationSectionElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.collection__results-pagination');
                                    for (let i = 0; i < paginationSectionElements?.length; i++) {
                                        paginationSectionElements[i].innerHTML = window.LB_GROWN_DIAMOND.initPaginationHTML(resultArray?.current_page,resultArray?.page_count);
                                    }
                                    window.LB_GROWN_DIAMOND.initPaginationButtonEvent();
                                    window.LB_GROWN_DIAMOND.showElements('.collection__results-pagination');
                                }
                                
                                window.LB_GROWN_DIAMOND.initViewButton();
                                window.LB_GROWN_DIAMOND.initListItemHover();
                                window.LB_GROWN_DIAMOND.initClearFiltersButton();
                                window.LB_GROWN_DIAMOND.initAddToCartButton();
                                window.LB_GROWN_DIAMOND.initShowAndHideIframe();
                                LB_GROWN_DIAMOND.initShopifyChatEvent();
                            } else {
                                if (window.LB_GROWN_DIAMOND.config.page_number == 1) {
                                    document.getElementById('search_diamond_count').innerHTML = `0 RESULTS`;
                                    document.querySelector("#collection-grid-html") && (document.querySelector("#collection-grid-html").innerHTML += '<li class="no-results" style="text-align: center; width: 100%;"><p>No diamonds meets your filter criteria.</p></li>');
                                    document.querySelector("#collection-list-html") && (document.querySelector("#collection-list-html").innerHTML += '<div class="no-results" style="text-align: center; width: 100%;"><p>No diamonds meets your filter criteria.</p></div>');
                                }
                            }
                        } else {
                            if (window.LB_GROWN_DIAMOND.config.page_number == 1) {
                                document.getElementById('search_diamond_count').innerHTML = `0 RESULTS`;
                                document.querySelector("#collection-grid-html") && (document.querySelector("#collection-grid-html").innerHTML += '<li class="no-results" style="text-align: center; width: 100%;"><p>No diamonds meets your filter criteria.</p></li>');
                                document.querySelector("#collection-list-html") && (document.querySelector("#collection-list-html").innerHTML += '<div class="no-results" style="text-align: center; width: 100%;"><p>No diamonds meets your filter criteria.</p></div>');
                            }
                        }
                        window.LB_GROWN_DIAMOND.hideElements('.load-more-div');
                        window.LB_GROWN_DIAMOND.showElements('#diamond-overview-details')
                    })
                    .catch(error => console.log('error', error));
            }
        },
        initViewButton: function () {
            if (window.LB_GROWN_DIAMOND.conObjToArrElements('.collection__results-list-action')?.length > 0) {
                let viewButtonElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.collection__results-list-action');
                if (viewButtonElements?.length > 0) {
                    for (let i = 0; i < viewButtonElements.length; i++) {
                        viewButtonElements[i].addEventListener('click', async function (e) {
                            const tdId = this.dataset.id;
                            const listId = this.dataset.listId;
                            const tdDisplay = this.dataset.display;
                            const tdVideo = this.dataset.video;
                            const tdImage = this.dataset.image;
                            const tdOnerror = this.dataset.onerror;

                            window.LB_GROWN_DIAMOND.conObjToArrElements('.collection__results-list-item--active')?.length > 0 && (window.LB_GROWN_DIAMOND.conObjToArrElements('.collection__results-list-item--active').forEach(i => i.classList.remove('collection__results-list-item--active')));
                            if (Array.from(document.querySelectorAll('.' + tdId + '-image-desk'))) {
                                Array.from(document.querySelectorAll('.' + tdId + '-image-desk')).forEach(e => {
                                    e.style.display = '';
                                    e.setAttribute('src', tdImage);
                                    e.setAttribute('onerror', tdOnerror);
                                });
                            }
                            viewButtonElements.forEach(i => document.querySelectorAll('.' + i.dataset.id + '-video-desk') && (document.querySelectorAll('.' + i.dataset.id + '-video-desk').forEach(e => e.src = '')));
                            document.getElementById('diamond-overview-details') && (document.getElementById('diamond-overview-details').innerHTML = '');
                            if (tdDisplay == "true") {
                                const viewDetails = document.querySelector('#' + listId);
                                viewDetails.classList.add('collection__results-list-item--active');
                                viewDetails.setAttribute('data-display', "false");
                                document.querySelectorAll('.' + tdId + '-video-desk').forEach(e => e.src = tdVideo);
                                window.LB_GROWN_DIAMOND.showProductDetailOnTooltip(tdId);
                                document.querySelector('[data-is-hover="yes"]') && (document.querySelector('[data-is-hover="yes"]').setAttribute('data-is-hover', 'no'));
                            }
                            window.LB_GROWN_DIAMOND.initShowAndHideIframe();
                        });
                    }
                }
            }

            if (window.LB_GROWN_DIAMOND.conObjToArrElements('.icon-close-wrapper')?.length > 0) {
                let iconCloseWrapper = window.LB_GROWN_DIAMOND.conObjToArrElements('.icon-close-wrapper');
                if (iconCloseWrapper?.length > 0) {
                    for (let i = 0; i < iconCloseWrapper.length; i++) {
                        iconCloseWrapper[i].addEventListener('click', async function (e) {
                            const tdId = this.dataset.id;
                            const listId = this.dataset.listId;
                            document.querySelector('#' + listId) && (document.querySelector('#' + listId).classList.remove('collection__results-list-item--active'));
                            document.getElementById('diamond-overview-details') && (document.getElementById('diamond-overview-details').innerHTML = '');
                            document.querySelector('[data-is-hover="no"]') && (document.querySelector('[data-is-hover="no"]').setAttribute('data-is-hover', 'yes'));
                            document.querySelectorAll('.' + tdId + '-video-desk').forEach(e => e.src = '');
                            if (Array.from(document.querySelectorAll('.' + tdId + '-image-desk'))) {
                                Array.from(document.querySelectorAll('.' + tdId + '-image-desk')).forEach(e => {
                                    e.setAttribute('src', '');
                                    e.setAttribute('onerror', '');
                                });
                            }
                        });
                    }
                }
            }
        },
        clearAllFiltersFun: async function () {
            window.LB_GROWN_DIAMOND.hideElements('.collection__results-pagination');
    
            let listItemAShapeStyleElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.list-item-a-shape-style');
            listItemAShapeStyleElements.forEach(i => i.dataset.shapeValue == defaultShape ? document.querySelectorAll('.' + i.dataset.module).forEach(e => e.classList.add('custom-filter--active')) : document.querySelectorAll('.' + i.dataset.module).forEach(e => e.classList.remove('custom-filter--active')));
    
            const defaultColorArray = colorData.split(',');
            $slider_color && ($slider_color.value1 = defaultColorArray[0]);
            $slider_color && ($slider_color.value2 = defaultColorArray[defaultColorArray?.length - 1]);
    
            const defaultClarityArray = clarityData.split(',');
            $slider_clarity && ($slider_clarity.value1 = defaultClarityArray[0]);
            $slider_clarity && ($slider_clarity.value2 = defaultClarityArray[defaultClarityArray?.length - 1]);
    
            const defaultCutArray = cutData.split(',');
            $slider_cut && ($slider_cut.value1 = defaultCutArray[0]);
            $slider_cut && ($slider_cut.value2 = defaultCutArray[defaultCutArray?.length - 1]);
    
            $slider_carat && ($slider_carat.value1 = defaultCaratMin);
            $slider_carat && ($slider_carat.value2 = defaultCaratMax);
    
            $slider_price && ($slider_price.value1 = defaultPriceMin);
            $slider_price && ($slider_price.value2 = defaultPriceMax);            
    
            $slider_table && ($slider_table.value1 = defaultTableMin);
            $slider_table && ($slider_table.value2 = defaultTableMax);
    
            $slider_depth && ($slider_depth.value1 = defaultDepthMin);
            $slider_depth && ($slider_depth.value2 = defaultDepthMax);
    
            const defaultPolishArray = polishData.split(',');
            $slider_polish && ($slider_polish.value1 = defaultPolishArray[0]);
            $slider_polish && ($slider_polish.value2 = defaultPolishArray[defaultPolishArray?.length - 1]);

            const defaultSymmetryArray = symmetryData.split(',');
            $slider_symmetry && ($slider_symmetry.value1 = defaultSymmetryArray[0]);
            $slider_symmetry && ($slider_symmetry.value2 = defaultSymmetryArray[defaultSymmetryArray?.length - 1]);

            const defaultFluorescenceArray = fluorescenceData.split(',');
            $slider_fluorescence && ($slider_fluorescence.value1 = defaultFluorescenceArray[0]);
            $slider_fluorescence && ($slider_fluorescence.value2 = defaultFluorescenceArray[defaultFluorescenceArray?.length - 1]);
            
            document.getElementById('certified-by-select') && (document.getElementById('certified-by-select').value = defaultCertifiedBy);
            window.LB_GROWN_DIAMOND.config.shapeValue = defaultShape;
            window.LB_GROWN_DIAMOND.config.colorValues = defaultColorArray?.length > 0 ? `${defaultColorArray[0]},${defaultColorArray[defaultColorArray?.length-1]}` : '';
            window.LB_GROWN_DIAMOND.config.clarityValues = defaultClarityArray?.length > 0 ? `${defaultClarityArray[0]},${defaultClarityArray[defaultClarityArray?.length-1]}` : '';
            window.LB_GROWN_DIAMOND.config.cutValues = defaultCutArray?.length > 0 ? `${defaultCutArray[0]},${defaultCutArray[defaultCutArray?.length-1]}` : '';
            window.LB_GROWN_DIAMOND.config.polishValue = defaultPolishArray?.length > 0 ? `${defaultPolishArray[0]},${defaultPolishArray[defaultPolishArray?.length-1]}` : '';
            window.LB_GROWN_DIAMOND.config.symmetryValue = defaultSymmetryArray?.length > 0 ? `${defaultSymmetryArray[0]},${defaultSymmetryArray[defaultSymmetryArray?.length-1]}` : '';
            window.LB_GROWN_DIAMOND.config.fluorescenceValue = defaultFluorescenceArray?.length > 0 ? `${defaultFluorescenceArray[0]},${defaultFluorescenceArray[defaultFluorescenceArray?.length-1]}` : '';
            window.LB_GROWN_DIAMOND.config.certifiedByValue = defaultCertifiedBy;
            window.LB_GROWN_DIAMOND.config.page_number = 1;
            totalResultIndex = 0;
    
            window.LB_GROWN_DIAMOND.config.sortingField = 'total_sales_price';
            window.LB_GROWN_DIAMOND.config.sortingSeq = 'ASC';
            await window.LB_GROWN_DIAMOND?.callBeforeLGDiamond();
        },
        initClearFiltersButton: function () {
            if (window.LB_GROWN_DIAMOND.conObjToArrElements('.clear-all-filters')?.length > 0) {
                let vdbLBClearAllFiltersElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.clear-all-filters');
                for (let i = 0; i < vdbLBClearAllFiltersElements.length; i++) {
                    vdbLBClearAllFiltersElements[i].addEventListener('click', async function(event) {
                        event.stopPropagation();
                        event.preventDefault();
                        window.LB_GROWN_DIAMOND.clearAllFiltersFun();
                    });
                }
            }
        },
        formatMoney: function (cents, format) {
            if (typeof cents == 'string') {
                cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = (format || moneyFormat);

            function defaultOption(opt, def) {
                return (typeof opt == 'undefined' ? def : opt);
            }

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ',');
                decimal = defaultOption(decimal, '.');
                if (isNaN(number) || number == null) {
                    return 0;
                }
                number = (number / 100.0).toFixed(precision);
                var parts = number.split('.'),
                    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                    cents = parts[1] ? (decimal + parts[1]) : '';
                return dollars + cents;
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
            }
            return formatString.replace(placeholderRegex, value);
        },
        showElements: function (element) {
            document.querySelectorAll(element).forEach((element) => element.style.display = 'block');
        },
        hideElements: function (element) {
            document.querySelectorAll(element).forEach((element) => element.style.display = 'none');
        },
        isJsonOrString: function (str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        formDataToJson: function(formData, removeFromArray) {
            let jsonData = {};
            formData.forEach((value, key) => {
                if (!removeFromArray.includes(key)) {
                    // Check if the value is a File object (e.g., for file inputs)
                    if (value instanceof File) {
                        (jsonData[key] = value.name); // You can modify this to handle files differently if needed.
                    } else {
                        if (key == 'page_number') {
                            (jsonData['page'] = value);
                        } else {
                            (jsonData[key] = value);
                        }
                    }
                }
            });
            return jsonData;
        },
        objectToQueryParams: function(obj) {
            return Object.entries(obj).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        },
        arrayToQueryParams: function(array) {
            return array.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        },
        getUrlParameter: function(sParam) {
            var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        },
        updateQueryStringParam: function(key, value) {
            var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''), urlQueryString = document.location.search, newParam = (value ? (key + '=' + value) : ''), params = newParam?.length > 0 && ('?' + newParam);

            // If the "search" string exists, then build params from it
            if (urlQueryString) {
                keyRegex = new RegExp('([\?&])' + key + '[^&]*');

                // If param exists already, update it
                if (urlQueryString.match(keyRegex) !== null) {
                    params = urlQueryString.replace(keyRegex, "$1" + newParam);
                } else { // Otherwise, add it to end of query string
                    params = newParam?.length > 0 && (urlQueryString + '&' + newParam);
                }
            }
            
            var outputString = params.toString().replace(/&+/g, '&');
            outputString = outputString.replace('?&','?');
            outputString = outputString.charAt(outputString.length - 1) === '&' ? outputString.slice(0, -1) : outputString;
            params && (window.history.replaceState({}, "", outputString));
        },
        handleize: function (str) {
            str = str.toLowerCase();
        
            var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
            
            // For the old browsers
            for (var i = 0; i < toReplace.length; ++i) {
                str = str.replace(toReplace[i], "");
            }
        
            str = str.replace(/\W+/g, "-");
        
            if (str.charAt(str.length - 1) == "-") {
                str = str.replace(/-+\z/, "");
            }
        
            if (str.charAt(0) == "-") {
                str = str.replace(/\A-+/, "");
            }
        
            return str
        },
        initAddToCartButton: function() {
            if (LB_GROWN_DIAMOND.conObjToArrElements('.add-to-cart')?.length > 0) {
                let vdbAddToCartElements = LB_GROWN_DIAMOND.conObjToArrElements('.add-to-cart');
                for (let i = 0; i < vdbAddToCartElements?.length; i++) {
                    vdbAddToCartElements[i].addEventListener('click', function () {
                        let _this = this;
                        let dataSelectItem = this.dataset.selectItem;
                        let productJson = document.getElementById(`${dataSelectItem}-textarea`) && document.getElementById(`${dataSelectItem}-textarea`).innerHTML;
                        let productObj = JSON.parse(productJson);

                        _this.setAttribute('disabled', 'disabled');
                        _this.classList.add('disabled');
                        _this.textContent = 'Adding item...';
                        if (Object.keys(productObj)?.length > 0) {
                            var formData = new FormData();
                            formData.append("action", "createProduct");
                            formData.append("shop", Shopify.shop);
                            formData.append('product_title', productObj?.long_title);
                            formData.append('product_price', productObj?.total_sales_price);
                            formData.append('stock_id', productObj?.id);
                            formData.append('stock_num', productObj?.stock_num);
                            formData.append('product_img', productObj?.image_url?.length > 0 ? productObj?.image_url : `${window.location.origin}${baseAppProxy}/images/no-image.png`);
            
                            fetch(`${baseAppProxy}/frontend.php`, {
                                method: 'POST',
                                body: formData
                            })
                            .then(response => response.text())
                            .then(result => {
                                let resultObj = JSON.parse(result);
                                if (resultObj.isSuccess == "1") {
                                    $addDiamondToCartTry = 0;
                                    let prop = {
                                        "Color": productObj?.color,
                                        "Clarity": productObj?.clarity,
                                    };
                                    window.LB_GROWN_DIAMOND.addToCart(_this, resultObj?.var_id, 1, prop);
                                }
                            });
                        } else {
                            swal("Oops!", "Something went wrong please try again later!", "error");
                            
                            _this.removeAttribute('disabled', 'disabled');
                            _this.classList.remove('disabled');
                            _this.textContent = 'Add to cart';
                        }
                    });
                }
            }
        }, 
        addToCart: async function(_this, variant_id, quantity = "1", properties = {}) {
            var formData = new FormData();
            formData.append("id", variant_id);
            formData.append("quantity", quantity);
            Object.entries(properties).forEach(entry => {
                const [key, value] = entry;
                formData.append("properties[" + key + "]", value);
            });

            const cart = document.querySelector('cart-drawer');
            if (cart) {
                formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                cart.setActiveElement(document.activeElement);
            }

            await fetch("/cart/add.js", {
                method: "POST",
                body: formData,
            }).then(response => {
                if (!response.ok) {
                    return response.json().then(errorResponse => {
                        throw { status: response?.status, message: errorResponse?.description };
                    });
                }
                return response.json();
            }).then(async result => {
                // setTimeout(() => { cart.renderContents(result); });
                location.href = '/cart'; //cart.open();
                _this.removeAttribute('disabled', 'disabled');
                _this.classList.remove('disabled');
                _this.textContent = 'Add to cart';
                return;
            })
            .catch((err) => {
                $addDiamondToCartTry++;
                if ($addDiamondToCartTry > 25) {
                    _this.removeAttribute('disabled', 'disabled');
                    _this.classList.remove('disabled');
                    _this.textContent = 'Add to cart';

                    swal("Oops!", err?.message, "error");
                    return;
                } else {
                    window.LB_GROWN_DIAMOND.addToCart(_this, variant_id, quantity, properties);
                    return;
                }
            });
            _this.innerHTML = 'Add to cart';
            _this.disabled = false;
        },
        priceInShopCurrency: function(vdb_dollar_price) {
            return (vdb_dollar_price);
            /*var shop_currency = cartCurrencyIsoCode;	//USD, GBP
            var currency_rate = 1;
    
            //Currency variable is coming from - https://cdn.shopify.com/s/javascripts/currencies.js
            if (Currency != undefined && Currency.rates != undefined && Currency.rates[shop_currency] != undefined) {
                if (shop_currency != 'USD') {
                    currency_rate = Currency.rates[shop_currency];
                }
            }
            return (vdb_dollar_price / currency_rate).toFixed(2);*/
        },
        shopCurrencyToDollar: function(shop_price) {
            var shop_currency = cartCurrencyIsoCode;	//USD, GBP
            var currency_rate = 1;
    
            //Currency variable is coming from - https://cdn.shopify.com/s/javascripts/currencies.js
            if (Currency != undefined && Currency.rates != undefined && Currency.rates[shop_currency] != undefined) {
                if (shop_currency != 'USD') {
                    currency_rate = Currency.rates[shop_currency];
                }
            }
            return ( shop_price * currency_rate).toFixed(2);
        },
        removeURLParameter: function(url, parameter) {
            //prefer to use l.search if you have a location/link object
            var urlparts = url.split('?');   
            if (urlparts.length >= 2) {
                var prefix = encodeURIComponent(parameter) + '=';
                var pars = urlparts[1].split(/[&;]/g);
        
                //reverse iteration as may be destructive
                for (var i = pars.length; i-- > 0;) {    
                    //idiom for string.startsWith
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                        pars.splice(i, 1);
                    }
                }
                return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
            }
            return url;
        },
        loadGridImages: function(){
            if (window.LB_GROWN_DIAMOND.conObjToArrElements('.grid-item-filter-image')?.length > 0) {
                let gridItemFilterImageElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.grid-item-filter-image');
                for (let i = 0; i < gridItemFilterImageElements.length; i++) {
                    const element = gridItemFilterImageElements[i];
                    const imageURL = element.dataset.gridImg || "";
                    const errorURL = element.dataset.gridImgError || "";
                    const isImageURL = element.getAttribute('src');
                    if (imageURL?.length > 0 && isImageURL?.length == 0) {
                        element.setAttribute('src', imageURL);
                        element.setAttribute('onerror', errorURL);
                    }
                    element.dataset.gridImg = "";
                }
            }
        },
        initPaginationButtonEvent: function () {
            if (window.LB_GROWN_DIAMOND.conObjToArrElements('.collection__results-pagination-link')?.length > 0) {
                let paginationButtonLoadNumberElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.collection__results-pagination-link');
                for (let i = 0; i < paginationButtonLoadNumberElements.length; i++) {
                    paginationButtonLoadNumberElements[i].addEventListener('click', async function() {
                        const page_number = this.dataset.current_page;
                        window.LB_GROWN_DIAMOND.config.page_number = (parseInt(page_number));

                        if (myCustomController !== null) {
                            myCustomController.abort();
                        }

                        ajaxCallDiamondListRunning = 'No';
                        document.getElementById('search_diamond_count').innerHTML = `0 RESULTS`;
                        document.querySelector("#collection-grid-html") && (document.querySelector("#collection-grid-html").innerHTML = "");
                        document.querySelector("#collection-list-html") && (document.querySelector("#collection-list-html").innerHTML = "");
                        window.LB_GROWN_DIAMOND.hideElements('.collection__results-pagination');

                        const targetOffset = document.getElementById('collection-results-filters').getBoundingClientRect().top + window.scrollY - 30;
                        window.scrollTo({
                            top: targetOffset,
                            behavior: 'smooth'
                        });
                        await window.LB_GROWN_DIAMOND?.callDiamondList();
                    });
                }
            }
        },
        initPaginationHTML(current_page,page_count,adjacent = 2){
            current_page = parseInt(current_page);
            page_count = parseInt(page_count);
            adjacent = parseInt(adjacent);
        
            var out = '<ul class="collection__results-pagination-list">';

            // first
            if(current_page>(adjacent+1)) {
                out+='<li class="collection__results-pagination-item"><a class="collection__results-pagination-link" data-current_page="1" href="javascript:;">1</a></li>';
            }
        
            // interval
            if(current_page>(adjacent+2)) {
                out+='<li class="collection__results-pagination-item is-disabled"><a class="collection__results-pagination-link" href="javascript:;">...</a></li>';
            }
        
            // pages
            let pmin = (current_page>adjacent) ? (current_page-adjacent) : 1;
            let pmax = (current_page<(page_count-adjacent)) ? (current_page+adjacent) : page_count;
            for(let i=pmin; i<=pmax; i++) {
                if(i==current_page) {
                    out+='<li class="collection__results-pagination-item collection__results-pagination-item--current"><a class="collection__results-pagination-link" href="javascript:;">'+i+'</a></li>';
                }else{
                    out+='<li class="collection__results-pagination-item"><a class="collection__results-pagination-link" data-current_page="'+i+'" href="javascript:;">'+i+'</a></li>';
                }
            }
        
            // interval
            if(current_page<(page_count-adjacent-1)) {
                out+='<li class="collection__results-pagination-item is-disabled"><a class="collection__results-pagination-link" href="javascript:;">...</a></li>';
            }
        
            // last
            if(current_page<(page_count-adjacent)) {
                out+='<li class="collection__results-pagination-item"><a class="collection__results-pagination-link" data-current_page="'+page_count+'" href="javascript:;">'+page_count+'</a></li>';
            }
            out+= '</ul>';
        
            return out;
        },
        initShowAndHideIframe: function () {
            let productImageFrameElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.product-image-frame');
            for (let element of productImageFrameElements) {
                element.querySelector('img') && (element.querySelector('img').style.display = '');
                element.querySelector('iframe') && (element.querySelector('iframe').style.opacity = 0);
                element.querySelector('iframe') && (element.querySelector('iframe').classList.remove('video-active'));
                element.querySelector('.play-button') && (element.querySelector('.play-button').style.display = 'flex');
                element.querySelector('.product__image_inner') && (element.querySelector('.product__image_inner').style.display = '');

                element.addEventListener('click', function(event) {
                    productImageFrameElements.forEach(e => {
                        element.querySelector('img') && (element.querySelector('img').style.display = '');
                        e.querySelector('iframe') && (e.querySelector('iframe').style.opacity = 0);
                        e.querySelector('iframe') && (e.querySelector('iframe').classList.remove('video-active'));
                        e.querySelector('.product__image_inner') && (e.querySelector('.product__image_inner').style.display = '');
                        e.querySelector('.play-button') && (e.querySelector('.play-button').style.display = 'flex');
                    });
                    
                    if (this.querySelector('iframe')) {
                        this.querySelector('img').style.display = 'none';
                        this.querySelector('iframe').style.opacity = 1;
                        this.querySelector('iframe').classList.add('video-active');
                        this.querySelector('.play-button') && (this.querySelector('.play-button').style.display = 'none');
                        this.querySelector('.product__image_inner') && (this.querySelector('.product__image_inner').style.display = 'none');
                    }
                });
            }
        },
        conObjToArrElements: function (element) {
            return Array.prototype.slice.call(document.querySelectorAll(element));
        },
        initListItemHover: function() {
            if (window.LB_GROWN_DIAMOND.conObjToArrElements('.list-item-hover')?.length > 0) {
                const listItemHoverElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.list-item-hover');
                listItemHoverElements.forEach(function (element) {
                    element.addEventListener('mouseleave', function (e) {
                        const isHover = document.querySelector('[data-is-hover]').dataset?.isHover;
                        if (isHover == 'yes') {
                            document.querySelector('[data-is-hover]') && (document.querySelector('[data-is-hover]').setAttribute('data-is-hover', 'yes'));
                            let detailHTML = `<div class="collection__results-diamond-overview-details">
                                <div class="collection__results-diamond-specs" data-shape="Round">
                                    <div class="diamond-data table">
                                        <div class="title">Table</div>
                                        <span class="diamond-data--pct">0.00</span>%
                                    </div>
                                    <div class="diamond-data girdle">
                                        <div class="title">Girdle</div>
                                        <span class="diamond-data--girdle">-</span>
                                    </div>
                                    <div class="diamond-data culet">
                                        <div class="title">Culet</div>
                                        <span class="diamond-data--culet">-</span>
                                    </div>
                                    <div class="diamond-data depth">
                                        <div class="title">Depth</div>
                                        <span class="diamond-data--depth">0.00</span>%
                                    </div>
                                </div>
                                <div class="collection__results-diamond-name">-</div>
                                <div class="collection__results-specs">
                                    <div class="sku">
                                        <div class="title">Depth</div>
                                        <div class="diamond-sku">-</div>
                                    </div>
                                    <div>
                                        <div class="title">Symmetry</div>
                                        <div class="diamond-data--symmetry">-</div>
                                    </div>
                                    <div>
                                        <div class="title">Measurements</div>
                                        <div class="diamond-data--measurements">-</div>
                                    </div>
                                    <div>
                                        <div class="title">Polish</div>
                                        <div class="diamond-data--polish">-</div>
                                    </div>
                                    <div>
                                        <div class="title">Table</div>
                                        <span class="diamond-data--table">0.00</span>
                                        <span class="pct">%</span>
                                    </div>
                                    <div>
                                        <div class="title">Girdle</div>
                                        <div class="diamond-data--girdle">-</div>
                                    </div>
                                    <div>
                                        <div class="title">Depth</div>
                                        <span class="diamond-data--depth">0.00</span>
                                        <span class="pct">%</span>
                                    </div>
                                    <div>
                                        <div class="title">Culet</div>
                                        <div class="diamond-data--culet">-</div>
                                    </div>
                                </div>
                            </div>`;
                            document.getElementById('diamond-overview-details') && (document.getElementById('diamond-overview-details').innerHTML = detailHTML);
                        }
                    });
                    element.addEventListener('mouseenter', function (e) {
                        const tdId = this.dataset.id;
                        const isHover = document.querySelector('[data-is-hover]')?.dataset?.isHover;
                        if (isHover == "yes") {
                            window.LB_GROWN_DIAMOND.showProductDetailOnTooltip(tdId);
                        }
                    });
                });
            }
        },
        showProductDetailOnTooltip: function(id) {
            const productObj = JSON.parse(document.getElementById(`${id}-textarea`).innerText) || {};
            if (Object.keys(productObj)?.length > 0) {
                var measurements_arr = [];
                if(productObj?.meas_length!=null && productObj?.meas_length!=''){
                    measurements_arr.push(productObj?.meas_length);
                }else{
                    measurements_arr.push('0.00');
                }
                if(productObj?.meas_width!=null && productObj?.meas_width!=''){
                    measurements_arr.push(productObj?.meas_width);
                }else{
                    measurements_arr.push('0.00');
                }
                if(productObj?.meas_depth!=null && productObj?.meas_depth!=''){
                    measurements_arr.push(productObj?.meas_depth);
                }else{
                    measurements_arr.push('0.00');
                }
                var measurements = measurements_arr.join('x');
                
                let detailHTML = `<div class="collection__results-diamond-overview-details">
                    <div class="collection__results-diamond-specs" data-shape="${productObj?.shape}">
                        <div class="diamond-data table">
                            <div class="title">Table</div>
                            <span class="diamond-data--pct">${productObj?.table_percent}</span>%
                        </div>
                        <div class="diamond-data girdle">
                            <div class="title">Girdle</div>
                            <span class="diamond-data--girdle">${productObj?.girdle_condition}</span>
                        </div>
                        <div class="diamond-data culet">
                            <div class="title">Culet</div>
                            <span class="diamond-data--culet">${productObj?.culet_size}</span>
                        </div>
                        <div class="diamond-data depth">
                            <div class="title">Depth</div>
                            <span class="diamond-data--depth">${productObj?.depth_percent}</span>%
                        </div>
                    </div>
                    <div class="collection__results-diamond-name">${productObj?.size} Ct ${productObj?.shape} Lab Created Diamond</div>
                    <div class="collection__results-specs">
                        <div class="sku">
                            <div class="title">SKU</div>
                            <div class="diamond-sku">${productObj?.stock_num}</div>
                        </div>
                        <div>
                            <div class="title">Symmetry</div>
                            <div class="diamond-data--symmetry">${productObj?.symmetry}</div>
                        </div>
                        <div>
                            <div class="title">Measurements</div>
                            <div class="diamond-data--measurements">${measurements}</div>
                        </div>
                        <div>
                            <div class="title">Polish</div>
                            <div class="diamond-data--polish">${productObj?.polish}</div>
                        </div>
                        <div>
                            <div class="title">Table</div>
                            <span class="diamond-data--table">${productObj?.table_percent}</span>
                            <span class="pct">%</span>
                        </div>
                        <div>
                            <div class="title">Girdle</div>
                            <div class="diamond-data--girdle">${productObj?.girdle_condition}</div>
                        </div>
                        <div>
                            <div class="title">Depth</div>
                            <span class="diamond-data--depth">${productObj?.table_percent}</span>
                            <span class="pct">%</span>
                        </div>
                        <div>
                            <div class="title">Culet</div>
                            <div class="diamond-data--culet">${productObj?.culet_size}</div>
                        </div>
                    </div>
                </div>`;
                document.getElementById('diamond-overview-details') && (document.getElementById('diamond-overview-details').innerHTML = detailHTML);
            }
        },
        initShopifyChatEvent: function() {
            if (LB_GROWN_DIAMOND.conObjToArrElements('.need-help-talk-to-an-expert')?.length > 0) {
                LB_GROWN_DIAMOND.conObjToArrElements('.need-help-talk-to-an-expert').forEach(function(element) {
                    element.addEventListener('click', function() {
                        if (document.querySelector('#ShopifyChat')) {
                            document.querySelector('#ShopifyChat').shadowRoot.querySelector('.chat-toggle').click();
                        }
                    });
                });
            }
        }
    };
}();

document.addEventListener("DOMContentLoaded", async function () {
    let cut_array = cutData?.length > 0 && cutData.split(',') || [],
    clarity_array = clarityData?.length > 0 && clarityData.split(',') || [],
    color_array = colorData?.length > 0 && colorData.split(',') || [],
    polish_array = polishData?.length > 0 && polishData.split(',') || [],
    symmetry_array = symmetryData?.length > 0 && symmetryData.split(',') || [],
    fluor_array = fluorescenceData?.length > 0 && fluorescenceData.split(',') || [];

    let selectDefaultShape = '';
    if (window.LB_GROWN_DIAMOND.getUrlParameter('ring-handle') && window.LB_GROWN_DIAMOND.getUrlParameter('shape')) {
        let listItemAShapeStyleElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.list-item-a-shape-style');
        if (listItemAShapeStyleElements?.length > 0) {
            for (let i = 0; i < listItemAShapeStyleElements.length; i++) {
                const element = listItemAShapeStyleElements[i];
                let getQueryParamShape = window.LB_GROWN_DIAMOND.getUrlParameter('shape');
                if (getQueryParamShape == "Trillion") {
                  getQueryParamShape = "Trilliant";
                }
                let supportedShapes = getQueryParamShape.split(',');
                supportedShapes = Array.prototype.slice.call(supportedShapes);
                supportedShapes = supportedShapes.map(e => e.replace('Cut', '').trim());
                if (supportedShapes.includes(element.dataset.shapeValue) == false) {
                    element.classList.add('hide'); // document.querySelectorAll('.' + element.dataset.module).forEach(e => e.classList.add('hide'));
                } else {
                    element.classList.add('visible-shape'); // document.querySelectorAll('.' + element.dataset.module).forEach(e => e.classList.add('visible-shape'));
                }
            }
        }

        if (window.LB_GROWN_DIAMOND.getUrlParameter('shape') == undefined) {
            if (document.getElementsByClassName('visible-shape')?.length > 0) {
                let visibleShapeElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.visible-shape');
                for (let i = 0; i < visibleShapeElements.length; i++) {
                    if (i==0) {
                        selectDefaultShape = visibleShapeElements[i].childNodes[1].dataset.shapeValue;
                        document.querySelectorAll('.' + visibleShapeElements[i].childNodes[1].dataset.module).forEach(e => e.classList.add('active-state'));
                    }
                }
            }
        } else {
            selectDefaultShape = window.LB_GROWN_DIAMOND.getUrlParameter('shape') !== undefined ? window.LB_GROWN_DIAMOND.getUrlParameter('shape').replace('Cut', '').trim() : defaultShape;
        }
    } else {
        selectDefaultShape = window.LB_GROWN_DIAMOND.getUrlParameter('shape') !== undefined ? window.LB_GROWN_DIAMOND.getUrlParameter('shape').replace('Cut', '').trim() : defaultShape;
    }
    if (window.LB_GROWN_DIAMOND.getUrlParameter('shape') !== undefined) {
        let listItemAShapeStyleElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.list-item-a-shape-style');
        if (listItemAShapeStyleElements?.length > 0) {
            const queryShape = window.LB_GROWN_DIAMOND.getUrlParameter('shape').replace('Cut', '').trim();
            for (let i = 0; i < listItemAShapeStyleElements.length; i++) {
                const element = listItemAShapeStyleElements[i];
                if(element.dataset.shapeValue == queryShape){
                    document.querySelectorAll('.' + element.dataset.module).forEach(e => e.classList.add('active-state'));
                } else {
                    document.querySelectorAll('.' + element.dataset.module).forEach(e => e.classList.remove('active-state'));
                }
            }
        }
    }
    if (window.LB_GROWN_DIAMOND.getUrlParameter('clarity')) {
        clarity_array = window.LB_GROWN_DIAMOND.getUrlParameter('clarity').split(',');
    }
    if (window.LB_GROWN_DIAMOND.getUrlParameter('cut')) {
        cut_array = window.LB_GROWN_DIAMOND.getUrlParameter('cut').split(',');
    }
    if (window.LB_GROWN_DIAMOND.getUrlParameter('color')) {
        color_array = window.LB_GROWN_DIAMOND.getUrlParameter('color').split(',');
    }
    if (window.LB_GROWN_DIAMOND.getUrlParameter('polish')) {
        polish_array = window.LB_GROWN_DIAMOND.getUrlParameter('polish').split(',');
    }
    if (window.LB_GROWN_DIAMOND.getUrlParameter('symmetry')) {
        symmetry_array = window.LB_GROWN_DIAMOND.getUrlParameter('symmetry').split(',');
    }
    if (window.LB_GROWN_DIAMOND.getUrlParameter('fluor')) {
        fluor_array = window.LB_GROWN_DIAMOND.getUrlParameter('fluor').split(',');
    }
    if (window.LB_GROWN_DIAMOND.getUrlParameter('shape') !== undefined && shapeData.split(',')?.length > 0) {
        let shapeList = shapeData.split(',') || [], queryParamShape = window.LB_GROWN_DIAMOND.getUrlParameter('shape').replace('Cut', '').trim();
        if (!shapeList.includes(queryParamShape)) {
            selectDefaultShape = '';
        }
    }

    if (window.LB_GROWN_DIAMOND.getUrlParameter('shape') == "Trillion") {
      selectDefaultShape = "Trilliant";
    }

    console.log({selectDefaultShape});
    window.LB_GROWN_DIAMOND.config = {
        page_number: parseInt(window.LB_GROWN_DIAMOND.getUrlParameter('page')) || 1,
        shapeValue: selectDefaultShape,
        colorValues: color_array?.length > 0 ? `${color_array[0]},${color_array[color_array?.length-1]}` : '',
        clarityValues: clarity_array?.length > 0 ? `${clarity_array[0]},${clarity_array[clarity_array?.length-1]}` : '',
        cutValues: cut_array?.length > 0 ? `${cut_array[0]},${cut_array[cut_array?.length-1]}` : '',
        polishValue: polish_array?.length > 0 ? `${polish_array[0]},${polish_array[polish_array?.length-1]}` : '',
        symmetryValue: symmetry_array?.length > 0 ? `${symmetry_array[0]},${symmetry_array[symmetry_array?.length-1]}` : '',
        fluorescenceValue: fluor_array?.length > 0 ? `${fluor_array[0]},${fluor_array[fluor_array?.length-1]}` : '',
        certifiedByValue: window.LB_GROWN_DIAMOND.getUrlParameter('lab') !== undefined ? window.LB_GROWN_DIAMOND.getUrlParameter('lab') : defaultCertifiedBy,
        sortingField: 'total_sales_price',
        sortingSeq: 'ASC'
    };
    await window.LB_GROWN_DIAMOND?.callDiamondList();

   /*  if(window.LB_GROWN_DIAMOND.getUrlParameter('ring-handle') !== undefined){
        document.querySelector('[data-view="grid"]').style.display = 'none';
        document.querySelector('[data-view="list"]').style.display = 'none';
    } */
    window.LB_GROWN_DIAMOND.initClearFiltersButton();
});

if (window.LB_GROWN_DIAMOND.conObjToArrElements('.list-item-a-shape-style')?.length > 0) {
    let listItemAShapeStyleElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.list-item-a-shape-style');
    if (listItemAShapeStyleElements?.length > 0) {
        for (let i = 0; i < listItemAShapeStyleElements.length; i++) {
            const element = listItemAShapeStyleElements[i];
            element.addEventListener('click', async function (e) {
                const module_class = this.dataset.module, shape_value = this.dataset.shapeValue;
                listItemAShapeStyleElements.forEach(i => document.querySelectorAll('.' + i.dataset.module).forEach(e => e.classList.remove('custom-filter--active')));
                (window.LB_GROWN_DIAMOND.config.shapeValue != shape_value && (document.querySelectorAll('.' + module_class).forEach(e => e.classList.toggle('custom-filter--active'))));
                window.LB_GROWN_DIAMOND.config.shapeValue = (window.LB_GROWN_DIAMOND.config.shapeValue != shape_value ? shape_value : '');
                await window.LB_GROWN_DIAMOND?.callBeforeLGDiamond();
            });
        }
    }
}

if (document.getElementById('advanced-filter-desk-view')) {
    const advancedFilterElement = document.getElementById('advanced-filter-desk-view'), advanceFilterWebElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.advance-filter-web');
    var deskOriginalText = advancedFilterElement.textContent;
    var deskNewText = "View Basic Filters";
    advancedFilterElement.addEventListener('click', () => {
        advancedFilterElement.textContent = (advancedFilterElement.textContent === deskOriginalText) ? deskNewText : deskOriginalText;
        advanceFilterWebElements.forEach(e => e.classList.toggle('hide'));
    });
}

let handleGlobalSliderEventsForDesk = async function() {
    if (myCustomController !== null) {
        myCustomController.abort();
    }

    if (document.getElementById('certified-by-select')) {
        const certifiedBySelectElement = document.getElementById('certified-by-select');
        window.LB_GROWN_DIAMOND.config.certifiedByValue = certifiedBySelectElement.value;
    }
    await window.LB_GROWN_DIAMOND?.callBeforeLGDiamond();
};

$slider_carat && ($slider_carat.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_carat && ($slider_carat.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_price && ($slider_price.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_price && ($slider_price.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_clarity && ($slider_clarity.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_clarity && ($slider_clarity.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_cut && ($slider_cut.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_cut && ($slider_cut.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_table && ($slider_table.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_table && ($slider_table.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_depth && ($slider_depth.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_depth && ($slider_depth.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_color && ($slider_color.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_color && ($slider_color.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_polish && ($slider_polish.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_polish && ($slider_polish.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_symmetry && ($slider_symmetry.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_symmetry && ($slider_symmetry.addEventListener('touchend', handleGlobalSliderEventsForDesk));

$slider_fluorescence && ($slider_fluorescence.addEventListener('mouseup', handleGlobalSliderEventsForDesk));
$slider_fluorescence && ($slider_fluorescence.addEventListener('touchend', handleGlobalSliderEventsForDesk));

document.getElementById('certified-by-select') && (document.getElementById('certified-by-select').addEventListener('change', handleGlobalSliderEventsForDesk));

if (window.LB_GROWN_DIAMOND.conObjToArrElements('.set_tab_view')?.length > 0) {
    let setTabViewElements = window.LB_GROWN_DIAMOND.conObjToArrElements('.set_tab_view');
    if (setTabViewElements?.length > 0) {
        for (let i = 0; i < setTabViewElements.length; i++) {
            const element = setTabViewElements[i];
            element.addEventListener('click', function (e) {
                var add = this.dataset.add;
                var remove = this.dataset.remove;

                setTabViewElements.forEach(e => e.classList.remove('active'));
                this.classList.add('active');
                if (document.getElementById("collection-results-filters")) {
                    const collectionResultsFilters = document.getElementById("collection-results-filters");
                    collectionResultsFilters.classList.remove(`collection__results-section--${remove}-active`);
                    collectionResultsFilters.classList.add(`collection__results-section--${add}-active`);
                }
                // window.LB_GROWN_DIAMOND.loadGridImages();
            });
        }
    }
}

if (document.getElementById('products-count-select')) {
    const productsCountSelect = document.getElementById('products-count-select');
    productsCountSelect.addEventListener('change', async function (e) {
        await window.LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });
}

if (document.getElementsByClassName('list-sorting-th')?.length > 0) {
    let sortingThElements = document.getElementsByClassName('list-sorting-th');
    sortingThElements = Array.prototype.slice.call(sortingThElements);
    for (let i = 0; i < sortingThElements.length; i++) {
        sortingThElements[i].addEventListener('click', async function() {
            for (var j = 0; j < sortingThElements.length; j++) {
                sortingThElements[j].classList.add('list-sorting_both');
                sortingThElements[j].classList.remove('list-sorting_asc');
                sortingThElements[j].classList.remove('list-sorting_desc');
            }

            const clickedElement = this;
            const thSortingField = clickedElement.getAttribute('data-sorting_field');
            const hiddenSortingField = window.LB_GROWN_DIAMOND.config.sortingField;
            const hiddenSortingSeq = window.LB_GROWN_DIAMOND.config.sortingSeq;
            if (hiddenSortingField == thSortingField) {
                if (hiddenSortingSeq == 'ASC') {
                    window.LB_GROWN_DIAMOND.config.sortingSeq = 'DESC';
                    clickedElement.classList.add('list-sorting_desc');
                    clickedElement.classList.remove('list-sorting_both');
                    clickedElement.classList.remove('list-sorting_asc');
                } else {
                    window.LB_GROWN_DIAMOND.config.sortingSeq = 'ASC';
                    clickedElement.classList.add('list-sorting_asc');
                    clickedElement.classList.remove('list-sorting_both');
                    clickedElement.classList.remove('list-sorting_desc');
                }
            } else {
                window.LB_GROWN_DIAMOND.config.sortingSeq = 'ASC';
                clickedElement.classList.add('list-sorting_asc');
                clickedElement.classList.remove('list-sorting_both');
                clickedElement.classList.remove('list-sorting_desc');
            }
            window.LB_GROWN_DIAMOND.config.sortingField = thSortingField;
            await window.LB_GROWN_DIAMOND?.callBeforeLGDiamond();
        });
    }
}
